import { ACCENTS, GLOW } from "./constants";

export const APP_FONT_SIZE = 18;
export const DEFAULT_ACCENT_PRESET = "teal-blue";
export const DEFAULT_GLOW_INTENSITY = "medium";

const ALLOWED_ACCENT_PRESETS = Object.keys(ACCENTS);

export function resolveAccentPreset(raw) {
  const value = String(raw || DEFAULT_ACCENT_PRESET).trim();
  return ALLOWED_ACCENT_PRESETS.includes(value) ? value : DEFAULT_ACCENT_PRESET;
}

export function getAccentPresetFromRuntime() {
  if (typeof window === "undefined") return DEFAULT_ACCENT_PRESET;
  return resolveAccentPreset(window.ECLIPTICA_ACCENT_PRESET);
}

export function getGlowAlpha() {
  return parseFloat(GLOW[DEFAULT_GLOW_INTENSITY] || GLOW.medium);
}
